import { useState } from "react";
import LastMenu from "./LastMenu";

import Mainmenu from "./MainMenu";
import you from '../../assets/images/boy.png'

import bot from '../../assets/images/happy.png'; 

const Accomodations = () =>{

    const [showMenu, setShowMenu] = useState(true);
    const [showFrame1, setShowFrame1] = useState(false);
    const [showFrame2, setShowFrame2] = useState(false);
    const [showFrame3, setShowFrame3] = useState(false);
    const [showFrame4, setShowFrame4] = useState(false);
    const [showFrame5, setShowFrame5] = useState(false);

    
      const [time, setTime] = useState(new Date());

    return (
        <>
            <div className="frame1 animated-frame">
            What do you want to know more about?
            </div>
            {showMenu &&
                <div className="menu-btns animated-frame">
                <button className="menu-btn" 
                    onClick={() =>{
                        setTime(new Date());
                        setShowMenu(false);
                        setShowFrame1(true);
                        setShowFrame2(false);
                        setShowFrame3(false);
                        setShowFrame4(false);
                        setShowFrame5(false);
                    }}
                >Extended Stay</button>
                <button className="menu-btn" 
                    onClick={() =>{
                        setTime(new Date());
                        setShowMenu(false);
                        setShowFrame1(false);
                        setShowFrame2(true);
                        setShowFrame3(false);
                        setShowFrame4(false);
                        setShowFrame5(false);
                    }}
                >Guests</button>
                <button className="menu-btn" 
                    onClick={() =>{
                        setTime(new Date());
                        setShowMenu(false);
                        setShowFrame1(false);
                        setShowFrame2(false);
                        setShowFrame3(true);
                        setShowFrame4(false);
                        setShowFrame5(false);
                    }}
                >Lodging</button>
                <button className="menu-btn" 
                    onClick={() =>{
                        setTime(new Date());
                        setShowMenu(false);
                        setShowFrame1(false);
                        setShowFrame2(false);
                        setShowFrame3(false);
                        setShowFrame4(true);
                        setShowFrame5(false);
                    }}
                >Meals</button>
                <button className="menu-btn" 
                    onClick={() =>{
                        setTime(new Date());
                        setShowMenu(false);
                        setShowFrame1(false);
                        setShowFrame2(false);
                        setShowFrame3(false);
                        setShowFrame4(false);
                        setShowFrame5(true);
                    }}
                >Restart the chat</button>
            </div>}

            {showFrame1 && (
                <>
                <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}
                </div>
                <div className="you-message">
                    <div className="frame2 animated-frame">
                    Extended Stay
                    </div>
                    </div>

                    <div className='chatbot'>
                    <img src={bot} alt="bot" className="bot" />
                    <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
                    </div>
                    <div className="frame1 animated-frame">
                    If you need accommodations pre- or post-program, you will need to reserve a room at a neighboring hotel. On-campus accommodations are not available for early arrival, late departure, or extended visits.
                    </div>
                    <LastMenu id={2} />
                </>
            )}

            {showFrame2 && (
                <>
                <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}
                </div>
                <div className="you-message">
                    <div className="frame2 animated-frame">
                    Guests
                    </div>
                    </div>

                    <div className='chatbot'>
                    <img src={bot} alt="bot" className="bot" />
                    <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
                    </div>
                    <div className="frame1 animated-frame">
                    On-campus accommodations are only available for program participants. You may reserve a room for anyone traveling with you at a neighboring hotel.
                     </div>
                    <LastMenu id={2} />
                </>
            )}

            {showFrame3 && (
                <>
                <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}
                </div>
                <div className="you-message">
                    <div className="frame2 animated-frame">
                    Lodging
                    </div>
                    </div>

                    <div className='chatbot'>
                    <img src={bot} alt="bot" className="bot" />
                    <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
                    </div>
                    <div className="frame1 animated-frame">
                    Participants live on campus in an Executive Education dorm in suites of eight single, private rooms arranged around a common area. Each bedroom has its own private bathroom. Accommodations and most meals are included in the program fee.
                    </div>
                    <LastMenu id={2} />
                </>
            )}

            {showFrame4 && (
                <>
                <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}
                </div>
                <div className="you-message">
                    <div className="frame2 animated-frame">
                    Meals
                    </div>
                    </div>

                    <div className='chatbot'>
                    <img src={bot} alt="bot" className="bot" />
                    <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
                    </div>
                    <div className="frame1 animated-frame">
                    Most meals are provided as part of the program fee and are served in an Executive Education dining facility near the classrooms. We offer a wide variety of food options and are prepared to address food allergies and special dietary requirements.
                    </div>
                    <LastMenu id={2} />
                </>
            )}

            {showFrame5 && (
                <>
                <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}
                </div>
                <div className="you-message">
                <div className="frame2">Restart the chat</div>
                </div>

                <div className='chatbot'>
                <img src={bot} alt="bot" className="bot" />
                <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
                </div>
                    <Mainmenu />
                </>
            )}



        </>
    );
}

export default Accomodations;